module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/luna/luna_maria-03c2bf52a45b2e07d15ef9e38b66bf84.gif";